import { render, staticRenderFns } from "./goods-columns.vue?vue&type=template&id=613d3a53&scoped=true&"
import script from "./goods-columns.vue?vue&type=script&lang=js&"
export * from "./goods-columns.vue?vue&type=script&lang=js&"
import style0 from "./goods-columns.vue?vue&type=style&index=0&id=613d3a53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613d3a53",
  null
  
)

export default component.exports